interface Props {
  width?: number | string
}

export function SkeletonText({width, ...props}: Props) {
  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <div style={{width}} className="Skeleton Skeleton--text" {...props}>
      &nbsp;
    </div>
  )
}
